import { IAutomationAppComponent, IAutomationObject } from "../../types";
import PortfolioInsights from "./PortfolioInsights";
import { schema } from "./types";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: undefined,
    OverviewPanel: undefined,
    OperatorPanel: undefined,
    addAppFilter: (app: IAutomationObject) => app.schema.startsWith("AutomationApps.ReportsAndStatistics.Portfolio"),
    createConfig:  {
        group: "ReportsAndStatistics",
        name: "Portfolio Insights",
        description: "Portfolio insightscollection",
        panel: PortfolioInsights,
        defaultState: {  },
        defaultProperties: [ ]
    },
}
